export const AUTH_TOKEN_KEY = "auth_token_key"
export const ITEMS = 'items'
